import state from '../../store/main/state'
import {Room} from "../../models/Rooms/Room";

const list = (params = {}) => {
    return state.client.get('/v2/messenger/rooms', {
        params: params
    })
        .then(({data}) => {
            const items = data || [];
            return items.map(item => new Room(item));
        });
};

const add = (roomId, userIds) => {
    return state.client.post(`/v2/messenger/rooms/${roomId}/members`, userIds);
};

const get = (roomId) => {
    return state.client.get(`/v2/messenger/rooms/${roomId}`)
        .then(({data}) => {
            return new Room(data);
        });
}

/**
 *
 * @param room {NewRoom}
 */
const createDirect = (room) => {
    return state.client.post(`/v2/messenger/rooms`, room)
        .then(({data}) => {
            return new Room(data);
        });
}


export {
    list,
    add,
    createDirect,
    get
}